/**
 * A homepage carousel's viewport on phones: stretched over the section's
 * 1.5rem gutter to the screen's edges, with the gutter as padding, so the
 * cards start on the gutter but scroll through it to the edge of the screen.
 */
export const HOME_MOBILE_BLEED = 'max-md:-mx-6 max-md:px-6';
